
// Definición de defaults

import { PaginacionProps } from "../global/PaginacionInterface";
import { ExpedienteProps, defaultExpediente } from "../recepcion/ExpedienteInterface";

export const defaultBuscarLibroRegistroResponse: BuscarLibroRegistroResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultBuscarLibroRegistro: BuscarLibroRegistro = { idAutoridad: 0, numeroReferencia: '' };

export const defaultLibroRegistro: LibroRegistroProps = { 
    idLibroRegistro:            0,
    idExpediente:               0,
    numeroExpediente:           '',
    actor:                      '',
    demandado:                  '',
    sentidoSentencia:           '',
    tipoRecurso:                '',
    sentidoFallo:               '', 
    bajaOtrosMotivos:           '',
    observaciones:              '',
    expediente:                 defaultExpediente,
};

// Creación de interfaces

export interface LibroRegistroProps {
    idLibroRegistro:            number;
    idExpediente:               number;
    numeroExpediente:           string;
    actor:                      string;
    demandado:                  string;
    sentidoSentencia:           string; 
    tipoRecurso:                string;
    sentidoFallo:               string;
    bajaOtrosMotivos:           string;
    observaciones:              string;
    fechaRecepcion?:            Date;
    fechaRadicacion?:           Date;
    fechaSentencia?:            Date;
    fechaAdmision?:             Date;
    expediente:                 ExpedienteProps;
}

export interface BuscarLibroRegistro {
    idAutoridad:        number;
    numeroReferencia:   string;
}

export interface BuscarLibroRegistroParams extends PaginacionProps, BuscarLibroRegistro { }

export interface BuscarLibroRegistroResponse {
    currentPageIndex:   number;
    pageCount:          number;
    recordCount:        number;
    records:            LibroRegistroProps[];
}

export interface GuardarObservaciones {
    id:             number;
    observaciones:  string;
}

export interface DescargarInformacionParams { 
    idAutoridad:        number;
    numeroReferencia:   string;
}